import React from 'react';
import { Form, Input, Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { CrawlerEntity } from '../../../domain/entities/Crawler';

interface CrawlerCodeModalProps {
  crawler?: CrawlerEntity;
  isSaving: boolean;
  onCancel: () => void;
  onResend: (crawler: CrawlerEntity) => Promise<void>;
  onSubmit: (crawler: CrawlerEntity, code: string, password: string) => Promise<void>;
}

interface CrawlerCodeFormValues {
  code: string;
  password?: string;
}

const CrawlerCodeModal: React.FC<CrawlerCodeModalProps> = ({ crawler, isSaving, onCancel, onResend, onSubmit }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<CrawlerCodeFormValues>();

  return (
    <Modal
      open={!!crawler}
      title={t('crawler-confirm-code', { ns: 'titles' })}
      okText={t('crawler-sign-in', { ns: 'buttons' })}
      cancelText={t('cancel', { ns: 'buttons' })}
      confirmLoading={isSaving}
      onCancel={onCancel}
      onOk={() => form.submit()}
      destroyOnClose
    >
      <Typography.Paragraph type="secondary">
        {t('crawler-code-hint', { ns: 'standard', phone: crawler?.phone ?? '' })}{' '}
        <Typography.Link disabled={isSaving} onClick={() => crawler && onResend(crawler)}>
          {t('crawler-resend-code', { ns: 'buttons' })}
        </Typography.Link>
      </Typography.Paragraph>
      <Form
        form={form}
        layout="vertical"
        preserve={false}
        requiredMark={false}
        onFinish={(values) => crawler && onSubmit(crawler, values.code, values.password ?? '')}
      >
        <Form.Item name="code" label={t('crawler-code', { ns: 'labels' })} rules={[{ required: true, message: t('crawler-code-required', { ns: 'errors' }) }]}>
          <Input autoFocus inputMode="numeric" autoComplete="one-time-code" />
        </Form.Item>
        <Form.Item name="password" label={t('crawler-password', { ns: 'labels' })} extra={t('crawler-password-hint', { ns: 'standard' })}>
          <Input.Password autoComplete="off" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CrawlerCodeModal;
